"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function addClass(element, className) {
    if (element.classList) {
        element.classList.add(className);
    }
    else if (!hasClass(element)) {
        element.className = element.className + ' ' + className;
    }
}
exports.addClass = addClass;
function hasClass(element, className) {
    if (element.classList) {
        return !!className && element.classList.contains(className);
    }
    else {
        return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
    }
}
exports.hasClass = hasClass;
function removeClass(element, className) {
    if (element.classList) {
        element.classList.remove(className);
    }
    else {
        element.className = element.className
            .replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1')
            .replace(/\s+/g, ' ')
            .replace(/^\s*|\s*$/g, '');
    }
}
exports.removeClass = removeClass;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/dom-helpers/class.js
// module id = 188
// module chunks = 0 1 2 3 4 5 6